<div class="headerContainer" *ngIf="dossierLoaded">
  <div class="dossierHeader" *ngIf="!modoBasico && dossierLoaded && project">
    <div class="row my-1 justify-content-center">
      <!-- <div class="col-12 col-md-12  col-lg-12">
      <button *ngIf="backVisible" class="btn btn-info float-right" (click)="routeBack()">
        <i class="fas fa-chevron-left"></i> {{ 'General.back' | translate }}
      </button>
    </div> -->
      <div class="col-12 col-md-6  col-lg-6 py-1">
        <h2 class="d-inline-block">
          <i class="fa fa-archive text-emphasis fa-2x d-none d-md-inline-block" aria-hidden="true"></i>
          <!--
        si no esta activada la opcion de info visible, se sustituye el link por un span
      -->
          <a (click)="openDossier(project)" *ngIf="infoVisible && project">
            <span *ngIf="project.contractFolderId"> {{ project.contractFolderId }}</span>
            <span *ngIf="!project.contractFolderId">{{ project.identifier }} </span>
          </a>
          <span *ngIf="!infoVisible && project">
            <span *ngIf="project.contractFolderId"> {{ project.contractFolderId }}</span>
            <span *ngIf="!project.contractFolderId">{{ project.identifier }}</span>
          </span>
          <span *ngIf="project.title" style="font-size: 0.7em;"> - {{ project.title }}</span>
          <span *ngIf="!project.title && project.name" style="font-size: 0.7em;"> - {{
            truncateDivisionDescription(project.name) }}</span>
           <span *ngIf="!project.title && !project.name" style="font-size: 0.7em;"> - {{ project.abbreviatedTitle }}</span>
        </h2>
        <i class="fas fa-spinner loading-spin m-l-sm text-navy" aria-hidden="true"></i>
      </div>
      <div class="col-12 col-md-6  col-lg-6 py-1">
        <button *ngIf="infoVisible" class="btn btn-info btn-xs" (click)="openDossier(project)">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <span> {{ 'General.info' | translate }}</span></button>
        <!-- <span class="text-navy"> ({{ dossier?.alias }})</span> -->
        <a *ngIf="favouriteVisible" (click)="toogleFavourite()"
          pTooltip="Marcar o desmarcar el expediente como favorito">
          <i class="fas fa-favourite m-l-sm " [ngClass]="classFavourite()"></i>
        </a>
        <i *ngIf="!favouriteVisible" class="fas fa-spinner loading-spin m-l-sm text-navy" aria-hidden="true"></i>
      </div>
      <!-- <div class="col-12 col-md-6  col-lg-6 py-1" style="text-overflow: ellipsis; overflow:hidden; white-space: nowrap;">
        <span class="m-b-0">
          <strong> {{ 'DossierHeader.object' | translate }} </strong>
          {{ dossier?.division?.description }}</span>
      </div>
      <div class="col-12 col-md-6  col-lg-6 py-1" style="text-overflow: ellipsis; overflow:hidden; white-space: nowrap;">
        <span class="m-b-0">
          <strong> Fase:</strong>
          {{ dossier?.division?.phase?.description }}</span>
      </div>
      <div class="col-12 col-sm-6  col-lg-6 py-1">
        <strong> {{ 'DossierHeader.procedure.type' | translate }}</strong>
        {{ dossier?.division?.procedure?.description }} / {{ dossier?.tipoExpteId?.description }}
      </div>
      <div class="col-12 col-sm-6  col-lg-6 py-1">
        <strong> {{ 'DossierHeader.budget' | translate }} </strong>
        {{ dossier?.presupSinIva | currency: 'EUR' }}
      </div> -->
    </div>
  </div>
  <div class="dossierHeader" *ngIf="modoBasico && dossierLoaded && project">
    <ng-container *ngIf="dossierLoaded; else loading">
      <h2 class="d-inline-block w-100">
        <!-- ICONO -->
        <i class="fa fa-archive text-emphasis fa-2x d-none d-md-inline-block" aria-hidden="true"></i>
        <!--  IDENTIFICADOR DEL EXPEDIENTE (CON LINK O NO EN FUNCION DE INFOVISIBLE)-->
        <span>
          <a (click)="openDossier(project)" *ngIf="infoVisible; else infoNotVisible"><span
              *ngIf="project.contractFolderId"> {{ project.contractFolderId }}</span>
            <span *ngIf="!project.contractFolderId"> {{ project.identifier }}</span>
          </a>
          <ng-template #infoNotVisible>
            <span *ngIf="project.contractFolderId"> {{ project.contractFolderId }}</span>
            <span *ngIf="!project.contractFolderId"> {{ project.identifier }}</span>
          </ng-template>
          <span *ngIf="project.title" style="font-size: 0.7em;"> - {{ project.title }}</span>
          <span *ngIf="!project.title && project.name" style="font-size: 0.7em;"> - {{
            truncateDivisionDescription(project.name) }}</span>
          <span *ngIf="!project.title && !project.name" style="font-size: 0.7em;"> - {{ project.abbreviatedTitle
            }}</span>

          <span *ngIf="division?.name" style="font-size: 0.7em;"> - {{ truncateDivisionDescription(division.name)
            }}</span>

        </span>
        <!-- ALIAS / TITULO -->
        <!-- <span class="text-navy" *ngIf="project.title">
          {{ project.title }}</span> -->
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
      </h2>
    </ng-container>
    <ng-template #buttons>
      <!-- BOTON DE INFO -->
      <div class="d-inline-block float-right m-r-lg">
        <a *ngIf="infoVisible" (click)="openDossier(project)" title="{{'DossierHeader.infolink' | translate}}">
          <i class="fa fa-info-circle text-info" aria-hidden="true"></i>
        </a>
        <!-- BOTON DE FAVORITO -->
        <a *ngIf="favouriteVisible && !favouriteChanging" (click)="toogleFavourite()"
          title="{{'DossierHeader.favlink' | translate}}">
          <i class="fas fa-favourite m-l-sm" [ngClass]="classFavourite()"></i>
        </a>
        <i *ngIf="favouriteVisible && favouriteChanging" class="fas fa-spinner loading-spin m-l-sm text-navy"
          aria-hidden="true"></i>
        <a *ngIf="showCalendarVisible" (click)="showCalendar()" title="Calendario">
          <i class="fas fa-calendar m-l-sm"></i>
        </a>
        <a *ngIf="showDocumentsVisible" (click)="showDocuments()" title="Documentos">
          <i class="fas fa-file-alt m-l-sm"></i>
        </a>
      </div>
    </ng-template>
    <ng-template #loading>
      <h2 class="d-inline-block">
        <!-- ICONO -->
        <i class="fa fa-archive text-emphasis fa-2x" aria-hidden="true"></i> Cargando datos del expediente <i
          class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      </h2>
    </ng-template>
  </div>
  <!-- TITULO DE LA PANTALLA (INDEPENDIENTE DEL EXPEDIENTE-->
  <div class="col-12" *ngIf="title">
    <h3 class="title">
      <i *ngIf="titleIcon" class="fa fa-lg" [ngClass]="titleIcon" aria-hidden="true"></i>
      <span class="d-none d-sm-inline"> {{ title }} </span>
    </h3>
  </div>
</div>